import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../lib/auth';

const GOOGLE_CLIENT_ID = '358130095693-11n9befoe3h292vkd1ol9hmatv93031b.apps.googleusercontent.com';

export default function GoogleSignInButton({ redirectTo = '/library' }) {
  const { signInWithGoogleCredential } = useAuth();
  const navigate = useNavigate();
  const wrapRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    function render() {
      if (cancelled) return;
      if (!window.google?.accounts?.id) { setTimeout(render, 200); return; }

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: async (response) => {
          try {
            await signInWithGoogleCredential(response.credential);
            navigate(redirectTo);
          } catch (err) {
            toast.error(err.message || 'Google sign-in failed');
          }
        },
      });

      if (btnRef.current) {
        const width = Math.min(wrapRef.current?.offsetWidth || 360, 400);
        window.google.accounts.id.renderButton(btnRef.current, {
          theme: 'outline',
          size: 'large',
          width,
          text: 'continue_with',
          shape: 'rectangular',
          logo_alignment: 'center',
        });
      }
    }

    render();
    return () => { cancelled = true; };
  }, [navigate, redirectTo, signInWithGoogleCredential]);

  return (
    <div ref={wrapRef} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <div ref={btnRef} style={{ borderRadius: 10, overflow: 'hidden' }} />
    </div>
  );
}
